import React, { useState } from "react";
import { Box, Button, Grid, MenuItem, TextField } from "@mui/material";
import { PAYMENT_METHOD_OPTIONS } from "../types/accountsTypes";

const PaymentForm = ({ onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    vendorId: "",
    paymentDate: "",
    paymentMethod: "bank_transfer",
    amount: {
      paidAmount: 0,
      unallocatedAmount: 0,
      currency: "INR",
      exchangeRate: 1,
    },
    instrument: {
      referenceNo: "",
    },
    notes: "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(formData);
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Vendor ID"
            value={formData.vendorId}
            onChange={(e) =>
              setFormData((p) => ({ ...p, vendorId: e.target.value }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Payment Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formData.paymentDate}
            onChange={(e) =>
              setFormData((p) => ({ ...p, paymentDate: e.target.value }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Payment Method"
            value={formData.paymentMethod}
            onChange={(e) =>
              setFormData((p) => ({ ...p, paymentMethod: e.target.value }))
            }
            fullWidth
          >
            {PAYMENT_METHOD_OPTIONS.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Amount"
            type="number"
            value={formData.amount.paidAmount}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                amount: { ...p.amount, paidAmount: Number(e.target.value) },
              }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Reference No"
            value={formData.instrument.referenceNo}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                instrument: { ...p.instrument, referenceNo: e.target.value },
              }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes"
            value={formData.notes}
            onChange={(e) =>
              setFormData((p) => ({ ...p, notes: e.target.value }))
            }
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" disabled={loading}>
          Save Payment
        </Button>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default PaymentForm;
